import avatarIcon from '../images/avatar.png';
import calendarIcon from '../images/calendar.png';
import markerIcon from '../images/marker.png';
import phaseIcon from '../images/phase.png';
import plusIcon from '../images/plus.png';
import stethiscopeIcon from '../images/stethiscope.png';
import testTubeIcon from '../images/test-tube.png';
import tickIcon from '../images/tick.png';

export const icons = {
  avatarIcon,
  calendarIcon,
  markerIcon,
  phaseIcon,
  plusIcon,
  stethiscopeIcon,
  testTubeIcon,
  tickIcon,
};
